// extracted by mini-css-extract-plugin
export default {"icon":"tooltipButtonStyle-icon__QH0dx"};